import { takeEvery, all, select, put } from 'redux-saga/effects'

import { getInstance } from './selectors'
import { unregisterInstance } from './actions'
import { actionTypes } from './constants'

import { destroy } from '../LKGridInstance'

function* manageDestroyInstance({ meta: { instanceName } }) {
  const gridInstance = yield select(getInstance, instanceName)

  if (gridInstance) {
    yield put(destroy(instanceName))
    yield put(unregisterInstance(instanceName))
  }
}

function* saga() {
  yield all([takeEvery(actionTypes.saga.DESTROY_INSTANCE, manageDestroyInstance)])
}

export default saga
